<template>
    <v-container class="mb-6">

        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>

        <!-- <v-row class="mt-5">
            <v-col cols="12" lg="8" offset-lg="2">
                <v-card class="mb-5">
                    <v-card-text>

                    </v-card-text>
                </v-card>
            </v-col>
        </v-row> -->
        <v-row align="center">
            <v-col cols="12" sm="4">
                <v-btn
                    color="primary"
                    href="/admin/new-store"
                    v-if="this.userRole === 'admin'"
                >Añadir nuevo</v-btn>
                <!-- exportar excel -->
                <v-btn
                    class="text-capitalize ml-2"
                    :href="`/admin/export-stores`"
                >
                    <v-icon class="mr-2" color="green">mdi-file-excel</v-icon>
                    Exportar
                </v-btn>
            </v-col>
            <v-col cols="12" sm="8">
                <form @submit.prevent="processSearch" style="width:100%" class="d-flex align-center">
                    <v-row no-gutters>
                        <v-col cols="12" sm="6">
                            <v-text-field
                                v-model="txtSearch"
                                label="Buscar negocio..."
                                outlined
                                dense
                                hide-details
                                type="text"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-select
                                :items="itemsTypeStores"
                                item-value="id"
                                item-text="name"
                                label="Tipo de tienda"
                                outlined
                                dense
                                hide-details
                                v-model="txtTypeStore"
                            ></v-select>
                        </v-col>
                    </v-row>
                    <v-btn
                        color="primary"
                        type="submit"
                        elevation="2"
                        icon
                        large
                        v-show="txtSearch !== '' || txtTypeStore !== ''"
                        class="ml-2"
                    >
                        <v-icon dark>
                            mdi-magnify
                        </v-icon>
                    </v-btn>
                    <v-btn
                        color="red"
                        icon
                        large
                        v-show="txtSearch !== '' || txtTypeStore !== ''"
                        @click="cleanSearch"
                        class="ml-2"
                    >
                        <v-icon dark>
                            mdi-close
                        </v-icon>
                    </v-btn>
                </form>
            </v-col>
        </v-row>

        <!-- card main -->
        <v-card class="elevation-2 mt-5">
            <v-card-title class="blue-grey darken-4 white--text">
                Lista de usuarios
            </v-card-title>

            <v-simple-table>
                <template v-slot:default>
                <thead>
                    <tr>
                        <th>·</th>
                        <th class="text-left">
                            Negocio
                        </th>
                        <th>
                            Id. Usuario
                        </th>
                        <th class="text-left">
                            Link
                        </th>
                        <th class="text-left">
                            Dueño
                        </th>
                        <th class="text-left">
                            Cant. puntos de ventas
                        </th>
                        <th class="text-left">
                            Cantidad de prods.
                        </th>
                        <th class="text-left">
                            <div class="d-flex align-center">
                                <span>
                                    Cantidad de Pedidos
                                </span>
                                <div class="wrap-order">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-up"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='DESC', orderBy='total_sales', getListStores()"
                                            ></span>
                                        </template>
                                        <span>{{ $t('Orden descendente') }}</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-down"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='ASC', orderBy='total_sales', getListStores()"
                                            ></span>
                                        </template>
                                        <span>{{ $t('Orden ascendente') }}</span>
                                    </v-tooltip>
                                </div>
                            </div>
                        </th>
                        <th class="text-left">
                            Clientes Tech Habilitado
                        </th>
                        <th class="text-left">
                            Estado
                        </th>
                        <th class="text-left blue-grey lighten-4">
                            Retorno sobre ventas en Bs.
                        </th>
                        <th class="text-left blue-grey lighten-4">
                            Retorno sobre ventas en %
                        </th>
                        <th class="text-left blue-grey lighten-4">
                            Retorno sobre inversión en Bs.
                        </th>
                        <th class="text-left blue-grey lighten-4">
                            Retorno sobre inversión en %
                        </th>
                        <th class="text-right">
                            Acciones
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in listStores" :key="index">
                        <td>
                            <v-btn
                                icon
                                :href="`/one/${item.user.id}/2jfqs6xkn7hqm7mxppgdjngqe8h0zx`"
                                title="Cambiar a..."
                            >
                                <v-icon color="grey">
                                    mdi-door-open
                                </v-icon>
                            </v-btn>
                        </td>
                        <td>{{ item.name_store }}</td>
                        <td class="text-center">
                            <b>{{ item.user.id }}</b>
                        </td>
                        <td>
                            <a :href="tmpSlug+item.slug" target="_blank">
                                {{ tmpSlug+item.slug }}
                                <v-icon x-small>mdi-open-in-new</v-icon>
                            </a>
                        </td>
                        <td>{{ item.user.name }}</td>
                        <td>{{ item.point_sale }}</td>
                        <td>{{ item.user.products_count }}</td>
                        <td>
                            {{ item.quantity_sales }}
                        </td>
                        <td>
                            <!-- <v-switch
                                v-model="item.state"
                                :label="`${(item.state)? 'Activo' : 'Inactivo'}`"
                                @change="changeStateProduct(item.id)"
                                hide-details
                            ></v-switch> -->
                            <v-switch
                                v-model="item.is_tech_enabled"
                                :label="`${(item.is_tech_enabled)? 'Si' : 'No'}`"
                                @change="changeStateTechStore(item.id)"
                                hide-details
                            ></v-switch>
                        </td>
                        <td>
                            <v-chip
                                :color="(item.state)?'green':'red'"
                                small
                                text-color="white"
                            >
                                {{ (item.state)?'Activo':'Inactivo' }}
                            </v-chip>
                        </td>
                        <td>{{ (item.sale_money).toFixed(2) }}</td>
                        <td>{{ (item.sale_porcent).toFixed(0) }}</td>
                        <td>{{ (item.invert_money).toFixed(2) }}</td>
                        <td>{{ (item.invert_porcent).toFixed(0) }}</td>
                        <td class="text-right">
                            <div class="d-flex justify-end">
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            v-bind="attrs"
                                            v-on="on"
                                            icon
                                            :href="`/admin/edit-store/${item.id}`"
                                        >
                                            <v-icon color="grey">
                                                mdi-pencil
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Editar</span>
                                </v-tooltip>

                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            v-bind="attrs"
                                            v-on="on"
                                            icon
                                            @click="duplicateStore(item.id)"
                                        >
                                            <v-icon color="grey">
                                                mdi-content-duplicate
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Duplicar</span>
                                </v-tooltip>

                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            v-bind="attrs"
                                            v-on="on"
                                            icon
                                            @click="deleteStore(item.id)"
                                            v-if="userRole==='admin'"
                                        >
                                            <v-icon color="grey">
                                                mdi-delete
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Eliminar</span>
                                </v-tooltip>
                            </div>
                        </td>
                    </tr>
                </tbody>
                </template>
            </v-simple-table>
        </v-card>
        <div class="text-right py-2" v-html="pageTable"></div>
        <v-pagination
            v-model="page"
            :length="totalPage"
            :total-visible="5"
            color="primary"
            @input="changePage"
            class="my-5"
        ></v-pagination>
        <!-- end card main -->

        <!-- overlay -->
        <v-overlay :value="overlay" opacity=".9" z-index="10">
            <v-progress-circular
                indeterminate
                size="64"
                color="primary"
            ></v-progress-circular>
        </v-overlay>
        <!-- end overlay -->

    </v-container>
</template>
<script>
export default {
    props: ['userRole'],
    data() {
        return {
            overlay: false,
            loading: false,
            breadcrumbs: [
                {
                    text: 'Negocios',
                    disabled: false,
                    href: '/admin/stores',
                },
                {
                    text: 'Todos',
                    disabled: true,
                    href: '',
                }
            ],
            tmpSlug: 'https://'+window.location.hostname+'/',
            // list data
            itemsTypeStores: [],
            listStores: [],
            pageTable: '',
            page: 1,
            totalPage: null,
            txtSearch: '',
            txtTypeStore: '',
            orderType: 'DESC',
            orderBy: 'created_at',
        }
    },
    mounted() {
        this.getTypeStores()
        this.getListStores()
    },
    methods: {
        /**
         * type stores
         */
        async getTypeStores() {
            await axios.get('/admin/list-types-stores')
            .then(response => {
                // console.log(response);
                this.itemsTypeStores = response.data
            })
            .catch(error => {
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
            })
        },
        /**
         * List categories
         */
        processSearch () {
            this.page = 1
            this.getListStores()
        },
        changePage (event) {
            this.page = event;
            this.getListStores()
        },
        cleanSearch () {
            if (this.txtSearch !== '' || this.txtTypeStore !== '') {
                this.listStores = []
                this.page = 1
                this.txtSearch = ''
                this.txtTypeStore = ''
                this.getListStores();
            }
        },
        async getListStores () {
            this.overlay = true
            await axios.post(`/admin/list-stores?page=${this.page}&search=${this.txtSearch}&type_store=${this.txtTypeStore}&order_by=${this.orderBy}&order_type=${this.orderType}`, {})
            .then(response => {
                // console.log(response)
                this.listStores = response.data.data
                this.totalPage = response.data.meta.last_page
                this.pageTable = `Mostrando <strong>${response.data.meta.from??0} - ${response.data.meta.to??0}</strong> de un total de <strong>${response.data.meta.total}</strong>`
                this.overlay = false
            })
            .catch(error => {
                // console.log(error)
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
                this.overlay = false
            })
        },
        /**
         * delete
         */
        deleteStore(id) {
            this.$confirm(
                'Se eliminará permanentemente del sistema, si no esta seguro de esto puede cambiar de estado a inactivo.',
                '¿Eliminar negocio?',
                'info', {
                showCloseButton: true,
                reverseButtons: true,
                confirmButtonText: 'Continuar',
                cancelButtonText: 'Cancelar',
            }).then(res => {
                if (res) {
                    axios.delete(`/admin/del-store/${id}`)
                    .then(response => {
                        // console.log(response);
                        if (response.data == 'ok') {
                            this.$alert('', 'Negocio eliminado con éxito.', 'success', {confirmButtonText: 'Continuar'})
                            this.getListStores()
                        }
                    })
                    .catch(error => {
                        // console.log(error)
                        if (error.response.status == 404 || error.response.status == 500) {
                            this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                        }
                    })
                }
            });
        },

        /**
         * duplicate
         */
        duplicateStore(id) {
            this.$confirm(
                'Esto incluye la duplicación de productos.',
                '¿Duplicar negocio?',
                'info', {
                showCloseButton: true,
                reverseButtons: true,
                confirmButtonText: 'Continuar',
                cancelButtonText: 'Cancelar',
            }).then(res => {
                if (res) {
                    axios.post(`/admin/duplicate-store`, {store: id})
                    .then(response => {
                        // console.log(response);
                        if (response.data == 'ok') {
                            this.$alert('', 'Negocio duplicado con éxito.', 'success', {confirmButtonText: 'Continuar'})
                            this.getListStores()
                        }
                    })
                    .catch(error => {
                        // console.log(error)
                        if (error.response.status == 404 || error.response.status == 500) {
                            this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                        }
                    })
                }
            });
        },
        async changeStateTechStore(store_id) {
            let selStore = this.listStores.find(s => s.id === store_id);

            try {
                await axios.post('/admin/change-tech-enabled-state', {
                    store_id: selStore.id,
                    state: selStore.is_tech_enabled
                });
            } catch (error) {}
        },
    },
}
</script>
